import {
	Box,
	Button,
	Divider,
	FormControl,
	Grid,
	InputLabel,
	MenuItem,
	Select,
} from "@mui/material";
import DvrIcon from "@mui/icons-material/Dvr";
import React from "react";
import { useState, useEffect } from "react";
import Alert from "../../../components/ui/Alert";
import { durationList, sizes } from "../analyzeUtils";
import { useDispatch, useSelector } from "react-redux";
import { getNewCustomerData, setState } from "../analyzeSlice";

const selectWidth = sizes.w200;
const selectHeight = sizes.h35;

export default function NewCustomerForm() {
	const [validate, setValidate] = useState({
		countryValidated:false,
		durationValidated:false
	});
	const [alert, setAlert] = useState({
		alertSeverity:"",
		alertDisplay:false,
		alertMessage:""
	})
	const dispatch = useDispatch();
	const state = useSelector((store) => store.analyze);
	const loginState = useSelector((store) => store.login);

	const { countries, selectedCountry, selectedCountryID, duration } = state;
	const {
		globalSelectedCountryName,
		globalSelectedCountryID,
	} = loginState

	function setCountry(event) {
		const name = event.target.value;
		const countryID = countries.find(
			(country) => country.countryName === name
		).countryID;
		if(name){
			setValidate({
				...validate, countryValidated:true
			})
		}
		dispatch(setState("selectedCountry", name));
		dispatch(setState("selectedCountryID", countryID));

		dispatch(setState("clearAnalyzeNewCustomer", false));
	}

	useEffect(() => {
		dispatch(setState("duration",null));
		dispatch(setState("clearAnalyzeNewCustomer", false));
	},[])

	useEffect(() => {
		if(globalSelectedCountryID !== null){
		dispatch(setState("selectedCountryID", globalSelectedCountryID));
		}
	},[globalSelectedCountryID])

	useEffect(() => {
		if(globalSelectedCountryName !== null){
		dispatch(setState("selectedCountry", globalSelectedCountryName));
		}
	},[globalSelectedCountryName])

	function setDuration(event) {
		const d = event.target.value;
		if(d){
			setValidate({
				...validate, durationValidated:true
			})
		}
		dispatch(setState("duration", d));
	}

	
	const displayAlert = (severityType) => {
		setAlert({
			"alertSeverity": "warning",
			"alertDisplay": true,
			"alertMessage": `Please select the ${severityType}`});
	}

	useEffect(() => {
		//Check if any of the dropdown are false and then set alertDisplay to false
		const isAnyKeyValueFalse = o => !!Object.keys(o).find(k => !o[k]);

		if(isAnyKeyValueFalse(validate)){
			setAlert({...Alert, alertDisplay:false});
		}
	},[validate])

	function handleDisplay() {
		const obj = {
			countryID: selectedCountryID,
			duration: duration,
		};

		//Alert if any of the dropdowns are not validated

		if(!validate.countryValidated){
			displayAlert("Country")
		}
		else if(!validate.durationValidated){
			displayAlert("Duration")
		}
		else{
			dispatch(setState("clearAnalyzeNewCustomer", true));
			dispatch(getNewCustomerData(obj));
		}	
	}

	return (
		<Box sx={{ mt: 3 }}>
			<Grid container columns={5} spacing={3} >
				<Grid item sm={2.25}>
					<FormControl>
						<InputLabel>Country</InputLabel>
						<Select
							value={selectedCountry}
							label="Country"
							sx={{
								height: selectHeight,
								width: selectWidth,
								color: "black.main",
								mt: 1,
							}}
							onChange={setCountry}
						>
							{countries.map((country, index) => {
								return (
									<MenuItem key={index} value={country.countryName}>
										{country.countryName}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
				</Grid>

				<Grid item sm={2.25}>
					<FormControl>
						<InputLabel>Duration</InputLabel>
						<Select
							value={duration}
							label="Duration"
							sx={{
								height: selectHeight,
								width: selectWidth,
								color: "black.main",
								mt: 1,
							}}
							onChange={setDuration}
						>
							{durationList.map((duration, index) => {
								return (
									<MenuItem key={index} value={duration.value}>
										{duration.label}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
				</Grid>

				<Grid item sm={.5}>
					<Button
						startIcon={<DvrIcon />}
						sx={{
							bgcolor: "blue.main",
							color: "white.main",
							textTransform: "none",
							fontWeight: "bold",
							"&:hover": {
								bgcolor: "skyBlue.main",
								color: "black.main",
							},
						}}
						onClick={handleDisplay}
					>
						Display
					</Button>
				</Grid>
			</Grid>
			{alert.alertDisplay && <Alert message={alert.alertMessage} severity={alert.alertSeverity} />}
			<Divider sx={{ mt: 3 }} />
		</Box>
	);
}
